import api from '../token';

export const DeleteBanco = async (dados) => {
  try {
    const response = await api.post('/deleteBanco', dados);
    return response.data;
  } catch (error) {
   
    return [];
  }
};




